(function () {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const getOpenDialog = () => document.querySelector('[data-size-modal-dialog]:not([hidden])');

  const setPageLocked = (locked) => {
    document.documentElement.classList.toggle('drapeur-size-modal-open', locked);
    document.body.classList.toggle('drapeur-size-modal-open', locked);
  };

  const openModal = (root, trigger) => {
    const dialog = root.querySelector('[data-size-modal-dialog]');
    const overlay = root.querySelector('[data-size-modal-overlay]');
    const content = root.querySelector('[data-size-modal-content]');
    if (!dialog || !overlay) return;

    root._trigger = trigger;
    root._prevFocus = document.activeElement;
    overlay.hidden = false;
    dialog.hidden = false;
    dialog.scrollTop = 0;
    if (content) content.scrollTop = 0;
    trigger.setAttribute('aria-expanded', 'true');
    setPageLocked(true);

    window.requestAnimationFrame(() => {
      const closeButton = root.querySelector('[data-size-modal-close]');
      (closeButton || dialog).focus();
    });
  };

  const closeModal = (root) => {
    const dialog = root.querySelector('[data-size-modal-dialog]');
    const overlay = root.querySelector('[data-size-modal-overlay]');
    if (!dialog || !overlay) return;

    overlay.hidden = true;
    dialog.hidden = true;
    if (root._trigger) root._trigger.setAttribute('aria-expanded', 'false');
    setPageLocked(Boolean(getOpenDialog()));

    const returnTarget = root._trigger || root._prevFocus;
    if (returnTarget && typeof returnTarget.focus === 'function') returnTarget.focus();
  };

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-size-modal-open]');
    const closeButton = event.target.closest('[data-size-modal-close]');
    const overlay = event.target.closest('[data-size-modal-overlay]');

    if (openButton) {
      event.preventDefault();
      const targetId = openButton.getAttribute('data-size-modal-target');
      const root = targetId && document.getElementById(targetId);
      if (root) openModal(root, openButton);
      return;
    }

    if (closeButton || overlay) {
      const root = event.target.closest('[data-size-modal]');
      if (root) closeModal(root);
      return;
    }

    const legacyLink = event.target.closest('a.open-size-guide');
    if (!legacyLink) return;

    event.preventDefault();
    const modalButton = document.querySelector('[data-size-modal-open]');
    if (modalButton) modalButton.click();
  });

  document.addEventListener('keydown', function (event) {
    const dialog = getOpenDialog();
    if (!dialog) return;

    const root = dialog.closest('[data-size-modal]');
    if (!root) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(root);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(dialog.querySelectorAll(focusableSelector)).filter((element) => {
      return element.offsetParent !== null;
    });

    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();


(function () {
  const labels = {
    fr: ['Taille petit', 'Taille légèrement petit', 'Taille normalement', 'Taille légèrement grand', 'Taille grand'],
    en: ['Runs small', 'Runs slightly small', 'True to size', 'Runs slightly large', 'Runs large']
  };
  const patterns = [
    /\btaille(?:nt)?\s+petite?\b|\bruns?\s+small\b/gi,
    /\btaille(?:nt)?\s+(?:plutôt|plutot|légèrement|legerement)\s+petite?\b|\bruns?\s+(?:slightly|a little)\s+small\b/gi,
    /\btaille(?:nt)?\s+normalement\b|\b(?:fits?\s+)?true\s+to\s+size\b/gi,
    /\btaille(?:nt)?\s+(?:plutôt|plutot|légèrement|legerement)\s+grande?\b|\bruns?\s+(?:slightly|a little)\s+large\b/gi,
    /\btaille(?:nt)?\s+grande?\b|\bruns?\s+large\b/gi
  ];
  const normalize = text => text.replace(/\s+/g, ' ').trim();
  const detect = text => {
    const found = patterns.flatMap((pattern, index) => {
      pattern.lastIndex = 0;
      return pattern.test(text) ? [index] : [];
    });
    return found.length === 1 ? found[0] : -1;
  };
  const removable = text => {
    if (/\b(?:cm|kg|mesure|mesures|mesurent|porte|porté|wears|measures|shrink|rétréc|retrec)/i.test(text)) return false;
    const sentences = text.match(/[^.!?]+[.!?]*/g) || [];
    return sentences.every(sentence => detect(sentence) !== -1 ||
      /^\s*(?:n['’]h[ée]site|pour choisir|consulte|r[ée]f[èe]re|please refer|refer to|see our)/i.test(sentence));
  };
  const trimAfterFeatures = description => {
    const lists = [...description.querySelectorAll('ul, ol')].filter(list =>
      !list.parentElement.closest('ul, ol'));
    const last = lists[lists.length - 1];
    if (!last) return;
    let node = last;
    while (node && node !== description) {
      while (node.nextSibling) node.nextSibling.remove();
      node = node.parentNode;
    }
  };
  const enhance = root => {
    if (root.dataset.fitAdviceReady) return;
    const descriptions = [...root.querySelectorAll('[data-drapeur-product-description]')];
    if (!descriptions.length) return;
    const oldNotes = [...root.querySelectorAll('.goodon-fit-note')];
    const source = [...descriptions, ...oldNotes].map(node => normalize(node.textContent)).join(' ');
    const index = detect(source);
    const language = document.documentElement.lang.toLowerCase().split('-')[0];
    const triggers = [...root.querySelectorAll('.drapeur-size-modal-trigger')];
    root.dataset.fitAdviceReady = 'true';
    if (index !== -1 && labels[language]) {
      if (!triggers.length) {
        const trigger = document.createElement('div');
        trigger.className = 'drapeur-size-modal-trigger drapeur-size-modal-trigger--advice-only';
        const variants = root.querySelector('.variant-wrapper--size, .variant-wrapper');
        if (variants) variants.append(trigger);
        else {
          const descriptionBlock = descriptions[0].closest('.product-block, .product-desc') || descriptions[0];
          descriptionBlock.parentNode.insertBefore(trigger, descriptionBlock);
        }
        triggers.push(trigger);
      }
      triggers.forEach(trigger => {
        const advice = document.createElement('span');
        advice.className = 'drapeur-fit-advice';
        advice.textContent = labels[language][index];
        trigger.classList.add('drapeur-size-modal-trigger--with-advice');
        trigger.append(advice);
      });
      oldNotes.forEach(note => {
        const block = note.closest('.product-block');
        if (block && normalize(block.textContent) === normalize(note.textContent)) block.remove();
        else note.remove();
      });
      descriptions.forEach(description => description.querySelectorAll('p').forEach(p => {
        if (!p.closest('ul, ol') && detect(normalize(p.textContent)) === index && removable(normalize(p.textContent))) p.remove();
      }));
    }
    descriptions.forEach(trimAfterFeatures);
  };
  const scan = scope => {
    if (scope.matches?.('[data-section-type="product"]')) enhance(scope);
    scope.querySelectorAll('[data-section-type="product"]').forEach(enhance);
  };
  const start = () => {
    scan(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          scan(node);
          const root = node.closest('[data-section-type="product"]');
          if (root) enhance(root);
        }
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

